module.exports = __webpack_public_path__ + "static/4-dbc38d788597bd67b184700f3ee7ab63.jpg";